import { render, staticRenderFns } from "./delegateView.vue?vue&type=template&id=43805d30&scoped=true"
import script from "./delegateView.vue?vue&type=script&lang=js"
export * from "./delegateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43805d30",
  null
  
)

export default component.exports